import { request, Loaded, getText } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Model, Msg, Model_get_Init } from "./Types.fs.js";
import { singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export function Http_getServerVersion() {
    return getText("/api/info/version");
}

export function State_init(page, user, lastModel) {
    return [Model_get_Init(), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    if (msg.tag === 1) {
        return [new Model(model.ClientVersion, Loaded(msg.fields[0])), Cmd_none()];
    }
    else {
        return [model, request(Http_getServerVersion, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
